import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vernacularBoolean'
})
export class VernacularBooleanPipe implements PipeTransform {

  transform(value: any): string {
    if (value === 1 || value === true) return "Yes";
    if (value === 0 || value === false) return "No";
    return value;
  }

}
